import { modelOptions, prop, Severity } from '@typegoose/typegoose';

@modelOptions({
  options: {allowMixed: Severity.ALLOW},
  schemaOptions: {_id: false}
})
export class RecommendationsModel {
  @prop({required: true})
  recommendationId: number;

  @prop({required: true})
  userProfilesCount: number;

  @prop({required: true})
  surfacePercentageReduction: number;

  @prop({required: true})
  recommendationType: number;
}
